import { createServiceDropdown } from "./fancy-dropdowns.3e2d7c0fd3ef.js";
import CustomAmplitudeClient from "./custom-amplitude-client.8d2468912b6f.js";
import { ModalFilter } from "./filters/modal_filter.68c7e8a137da.js";
import"./filters/index.cf66dc3ab756.js"; // Import file so we do not lose it in linting
import { ContactUs } from "./contact-us.269e211569d4.js";
import { PriceVerification } from "./price-verification.dd5aa8a1f36a.js";
import { CareQuality } from "./care-quality.cec8f0ad45fa.js";
import { MOBILE_SCREEN_QUERY } from "./shared.3c04262e7f5d.js";
import {
  OpenInsuranceSelectorEvent,
  InsuranceSelectorChangedEventType,
} from "./insurance-selector-events.87d20ca02104.js";
import { LocationSelectorChangedEventType } from "./location-selector.1c3ab5587b7c.js";
import { ServiceSelectorChangedEventType } from "./service-selector-events.5a616c64e072.js";
import { MobileMapController } from "./mobile-map-controller.5a7cd380ab4d.js";

class SearchPage {
  constructor() {
    this.config = JSON.parse(
      document.getElementById("page-config").textContent,
    );
    if (!this.config) throw new Error("unable to load page config");

    this.rates = JSON.parse(document.getElementById("rates-data").textContent);
    if (!this.rates) throw new Error("unable to load embedded rates");

    this.elements = this.queryDomElements();
    this.mapController = new MobileMapController(
      document.getElementById("map-toggle"),
    );
    new ModalFilter();
    new PriceVerification();
    new CareQuality();
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);

    this.bindInputHandlers();
    if (this.elements.searchBarPopover) {
      this.amplitudeClient.setupSearchBarAnalytics(
        this.elements.searchBarPopover,
      );
    }
    this.bindFilterHandlers();
    this.bindEventListeners();
  }

  queryDomElements = () => {
    return {
      ratesForm: document.getElementById("rates-form"),
      openMobileSearchButton: document.getElementById("open-mobile-search"),
      closeMobileSearchButton: document.querySelectorAll(
        ".search-bar--popover .mobile-close",
      ),
      searchBarPopover: document.querySelector(".search-bar--popover"),
      checkCoverageLinks: document.querySelectorAll(".tqc-check-coverage"),
      modalForm: document.getElementById("all-filters-form"),
      exclusionsSwitch: document.getElementById("exclusions-switch"),
      packageInfoSection: document.getElementById("package-info-container"),
    };
  };

  bindEventListeners() {
    document.body.addEventListener("htmx:afterSettle", (e) => {
      // Re-query and bind elements that may have been replaced by htmx swap
      this.elements = this.queryDomElements();
      this.bindInputHandlers();
      new ModalFilter();
      new PriceVerification();
      new CareQuality();
      // Reapply visibility state after all swaps complete
      this.mapController.updateMapVisibility(
        this.mapController.isMapVisibleOnMobile,
      );
    });
    const closeableEvents = [
      InsuranceSelectorChangedEventType,
      LocationSelectorChangedEventType,
      ServiceSelectorChangedEventType,
    ];
    for (const closeableEvent of closeableEvents) {
      document.addEventListener(closeableEvent, (e) => {
        if (MOBILE_SCREEN_QUERY.matches) {
          this.closeMobileSearchOverlay();
        }
      });
    }
  }

  bindInputHandlers() {
    if (this.elements.exclusionsSwitch) {
      this.elements.exclusionsSwitch.addEventListener(
        "change",
        this.exclusionsSwitchChange,
      );
    }
    if (this.elements.openMobileSearchButton) {
      this.elements.openMobileSearchButton.addEventListener(
        "click",
        this.openMobileSearchOverlay,
      );
    }
    this.elements.closeMobileSearchButton.forEach((button) => {
      button.addEventListener("click", this.closeMobileSearchOverlay);
    });
    this.elements.checkCoverageLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (MOBILE_SCREEN_QUERY.matches) {
          this.openMobileSearchOverlay();
          document.dispatchEvent(
            new OpenInsuranceSelectorEvent(false, {
              navMethod: "check-coverage",
            }),
          );
        } else {
          document.dispatchEvent(
            new OpenInsuranceSelectorEvent(true, {
              navMethod: "check-coverage",
            }),
          );
        }
        // I have a hypothesis that users wont use this,
        // so tracking its usage.
        this.amplitudeClient.trackEvent("workflow_started", {
          workflow: "check_coverage",
        });
      });
    });
  }

  bindFilterHandlers() {
    document.addEventListener("tq:resetfilter", (e) => {
      this.elements = this.queryDomElements();
      const form = e.target.id.includes("all-filters")
        ? this.elements.modalForm
        : this.elements.ratesForm;
      for (const [formKey, filterValue] of Object.entries(e.detail)) {
        let element = form.elements[formKey];
        if (element instanceof RadioNodeList) {
          // RadioNodeLists are a collection of radio/checkboxes. Using RadioNodeList#value= works for setting a value,
          // but not for unchecking a radio button. This is needed to reset `care_quality` to be unselected
          for (let input of element) {
            input.checked = input.value === filterValue;
          }
        } else {
          if (filterValue == "null") {
            element.value = null;
          } else {
            element.value = filterValue;
          }
        }
      }
      form.elements["action"].value = "filter";
      form.submit();
    });
  }

  exclusionsSwitchChange = (evt) => {
    let func = "remove";
    if (evt.target.checked) {
      func = "add";
    }

    // save this cookie for 30 days
    document.cookie = `consumer_price_verification_enabled=${
      evt.target.checked
    }; max-age=${60 * 60 * 24 * 30}`;
    const verifiers = document.querySelectorAll(".tqc-package-result-card");
    verifiers.forEach((verifier) => verifier.classList[func]("tqc-verified"));
  };

  openMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.remove("pv-hide-on-small");
    this.elements.searchBarPopover.classList.add("pv-inset-square-16");
  };

  closeMobileSearchOverlay = () => {
    this.elements.searchBarPopover.classList.add("pv-hide-on-small");
    this.elements.searchBarPopover.classList.remove("pv-inset-square-16");
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new SearchPage();
});
